import { useMemo } from "react";
import { formatMomentDate } from "../../utils/dateHelper";
import StatusChip from "../../components/statusChip/StatusChip";
import { BankIcons } from "../../utils/otherHelopers";
import { useNavigate } from "react-router-dom";
import { TableSearch } from "../../components/form/Fields";
import CustomTable from "../../components/table/CustomTable";

const List = ({
  data,
  searchTerm,
  setSearchTerm,
  setCurrentPage,
  pagination,
}) => {
  const navigate = useNavigate();

  const columns = useMemo(() => [
    {
      id: "name",
      header: "NAME",
      cell: (_, row) => row?.profile && row?.profile?.name ? row?.profile?.name : "-"
    },
    {
      id: "mobile_number",
      header: "MOBILE NUMBER",
      cell: (_, row) => row?.mobile_number ? row?.mobile_number : "-"
    },
    {
      id: "email",
      header: "EMAIL ADDRESS",
      cell: (_, row) => row?.email ? row?.email : "-"
    },
    {
      id: "designation",
      header: "DESIGNATION",
      cell: (_, row) => row?.profile && row?.profile?.designation ? row?.profile?.designation : "-"
    },
    {
      id: "bank_name",
      header: "BANK NAME",
      className: "text-start",
      cell: (_, row) => row?.profile?.bank ? <>{BankIcons(row?.profile?.bank?.bank_name)}{" "} {row?.profile?.bank?.bank_name}</> : "-"
    },
    {
      id: "branch_city",
      header: "BRANCH CITY",
      cell: (_, row) => row?.profile?.branch ? row?.profile?.branch?.branch_city : "-"
    },
    {
      id: "created_at",
      header: "USER CREATED",
      className: "text-start",
      cell: (_, row) => (
        <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
          <span>{row?.created_at ? formatMomentDate(row.created_at, "DD MMM YYYY") : ""}</span>
          <span>{row?.created_at ? formatMomentDate(row.created_at, "hh:mm A") : ""}</span>
        </div>
      )
    },
    {
      id: "is_active",
      header: "ACTIVE/INACTIVE",
      isSwitch: true,
      checked: (row) => row?.is_active,
      onSwitchChange: () => { }
    },
    {
      id: "status",
      header: "STATUS",
      className: "text-capitalize",
      cell: (_, row) => row?.status && (
        <StatusChip pill bg={row?.status === "pending" ? "warning" : row?.status === "approved" ? "success" : row?.status === "rejected" ? "danger" : ""} title={row?.status} className="text-capitalize" />
      )
    }
  ], []);

  const actionList = useMemo(() => [
    {
      title: "View",
      handler: (row) => {
        navigate(`/npa-properties/property-details/${row.id}`);
      }
    },
    {
      title: "Edit",
      handler: () => { }
    },
    {
      title: "Delete",
      handler: (row) => {
        navigate(`/npa-properties/property-details/${row.id}`);
      }
    },
    {
      title: "Block",
      handler: () => { }
    },
    {
      title: "Inactive",
      handler: () => { }
    }
  ], [navigate]);

  return (
    <>
      <div className="p-4 d-flex align-items-center justify-content-between gap-4">
        <TableSearch value={searchTerm}
          placeholder="Search"
          onChange={(e) => {
            setSearchTerm(e.target.value);
            setCurrentPage(1);
          }} />
      </div>

      <CustomTable
        data={data || []}
        columns={columns}
        emptyMessage="No OTP messages found"
        keyField="id"
        actionList={actionList}
        pagination={pagination}
      />
    </>
  );
};

export default List;
